<template>
    <div class="finish-item" :key="id">
        <div class="finish-list-item-tooltip" v-if="store.isHovered">
            {{displayName}}
        </div>
        <div @mouseover="showTooltip" @mouseout="hideTooltip" class="finish-grid-list__item" @click="handleSelectFinish">
            <img :src="optimizedImageUrl" alt="" class="finish-grid-list__img" :class="{ 'finish-grid-list__img-selected': isSelected, 'finish-grid-list__img-disabled': isDisabled }" />
        </div>
    </div>
</template>

<script setup lang="ts">
import { reactive, computed } from 'vue';
import { useStore } from 'vuex';
import CompatibilityModal from "Vue/components/lockDesigner/components/shared/Modals/CompatibilityModal.vue";
const store2 = useStore();

const props = defineProps({
    id: String,
    displayName: String,
    description: String,
    imageUrl: String,
    route: String,
    isSelected: Boolean,
    isDisabled: Boolean,
    fieldId: String,
    compatibilityMessage: String,
    compatibilityModalMessage: String
});
const emit = defineEmits(['update-route', 'update-selection']);
const store = reactive({
    isHovered: false,
});

const isFinishLoading = computed(() => {
    return store2.state.isFinishLoading;
});

const handleSelectionContinue = () => {
	emit('update-selection', { selection: props, fieldId: props.fieldId });
};

const handleSelectFinish = async() => {
	if(props.isDisabled) {
		await store2.dispatch('openModal', {
			component: CompatibilityModal,
			props: { compatibilityModalMessage: props.compatibilityModalMessage, handleContinueSelection: handleSelectionContinue },
		});
		return;
	}
	handleSelectionContinue();
}
function showTooltip() {
    store.isHovered = true;
}
function hideTooltip() {
    store.isHovered = false;
}

const optimizedImageUrl = computed(() => {
    return `${props.imageUrl}&wid=31`
})
</script>
